import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Heading, Text, Button, TextArea } from '@components/common';
import { MobileContainer } from '@containers/layout';
import API from '@utils/api';
import { BookingSelectors } from '@redux/BookingRedux';
import { trackOnetimeAdditionalInstructions } from '@services/analytics';
import { getErrors } from '@utils/error';

function AdditionalInstructions(props) {
  const [note, setNote] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const { onSubmit, bookingId } = props;

  const handleSubmit = async () => {
    if (!note) {
      onSubmit();
      return;
    }

    try {
      setSubmitting(true);
      await API.updateBookingNote(bookingId, note);
      trackOnetimeAdditionalInstructions(bookingId, note);
      onSubmit(note);
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrMsg(error.message);
      } else {
        const msg = Object.values(error).pop();
        setErrMsg(msg);
      }
    }
    setSubmitting(false);
  };

  const handleOnChange = e => {
    setNote(e.target.value);
    setErrMsg('');
  };

  const isDisabled = isSubmitting;

  return (
    <MobileContainer>
      <Heading display={['none', 'block']} mb={4} textAlign="center">
        Helpful Hints
      </Heading>
      <Text display={['block', 'none']} pb={4} textAlign="center">
        Helpful Hints
      </Text>
      <Text display={['none', 'block']} pb={2}>
        Is there anything else you'd like your housekeeper to know?
      </Text>
      <TextArea
        height={['calc(79vh - 120px)', 443]}
        mb={4}
        value={note}
        onChange={handleOnChange}
        placeholder="Tell us your pet's name, where you keep the treats, or areas where you want extra focus."
      />
      {errMsg && (
        <Text fontSize={1} mb={4} color="red">
          {errMsg}
        </Text>
      )}
      <Button
        width={1}
        mb={4}
        type="button"
        onClick={handleSubmit}
        disabled={isDisabled}
      >
        Continue
      </Button>
    </MobileContainer>
  );
}

AdditionalInstructions.propTypes = {
  onSubmit: PropTypes.func,
  bookingId: PropTypes.any
};

const mapStatesToProps = state => ({
  bookingId: BookingSelectors.selectExistingBookingId(state)
});

export default connect(mapStatesToProps)(AdditionalInstructions);
